module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding\" style=\"margin-top: 10px!important; margin-bottom:16px!important;\">\r\n        <div style=\"display: inline-flex;\">\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"importTheme\" class=\"btn btn-default hvr-glow\" style=\"width:100%; padding: 8px;\">Import Theme</button>\r\n            </div>\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"exportTheme\" class=\"btn btn-default hvr-glow\" style=\"width:100%; padding: 8px;\">Export Theme</button>\r\n            </div>\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"resetTheme\" class=\"btn btn-default hvr-glow\" style=\"width:100%; padding: 8px;\">Reset Theme</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}